import moment from 'moment/moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import TableAdmin from '@/components/TableAdmin';

import './style.scss';

interface IProps {
    data: any;
    onChangePage: (page: number, pageSize: number) => void;
    filter: any;
    fetchData: () => void;
}

const Content = ({ data, onChangePage }: IProps) => {
    const { t } = useTranslation(['common', 'ticket']);
    const { pageResult } = data;

    const tableData =
        data?.data?.map((item: any, index: number) => ({
            key: index,
            id: item?.id,
            name: item?.payload?.ticket?.name,
            issuedQuantity: item?.payload?.issuedQuantity,
            mobileNo: item?.payload?.mobileNo,
            createdAt: item?.createdAt,
        })) || [];

    const columns = useMemo(
        () => [
            {
                id: 1,
                title: t('ticket:ISSUED_AT'),
                align: 'center',
                dataIndex: 'createdAt',
                render: (date: string) => <span>{moment(date).format('YYYY/MM/DD HH:mm')}</span>,
            },
            {
                id: 2,
                title: t('ticket:NAME'),
                dataIndex: 'name',
                align: 'center',
            },
            {
                id: 3,
                title: t('ticket:ISSUED_QUANTITY'),
                align: 'center',
                dataIndex: 'issuedQuantity',
            },
            {
                id: 4,
                title: t('ticket:MOBILE_NO'),
                align: 'center',
                dataIndex: 'mobileNo',
            },
        ],
        [t],
    );

    return (
        <div className="p-ticket-content">
            <TableAdmin
                showSizeChanger={false}
                columns={columns}
                data={tableData}
                pagination
                total={pageResult.total}
                currentPage={Number(pageResult.currentPage)}
                pageSize={pageResult.pageSize}
                onChangePage={(page: number, pageSize: number) => {
                    onChangePage(page, pageSize);
                }}
            />
        </div>
    );
};

export default Content;
